export const STORE_FETCHED_CATEGORIES = 'STORE_FETCHED_CATEGORIES'
export const CATEGORIES_LOADED = 'CATEGORIES_LOADED'

export const STORE_FETCHED_PAGES = 'STORE_FETCHED_PAGES'
export const PAGES_LOADED = 'PAGES_LOADED'

export const STORE_FETCHED_POSTS = 'STORE_FETCHED_POSTS'
export const POSTS_LOADED = 'POSTS_LOADED'

export const STORE_FETCHED_USER = 'STORE_FETCHED_USER'
export const LOGIN_USER = 'LOGIN_USER'
export const LOGOUT_USER = 'LOGOUT_USER'

export const INCREMENT_LOADING_PROGRESS = 'INCREMENT_LOADING_PROGRESS'
export const RESET_LOADING_PROGRESS = 'RESET_LOADING_PROGRESS'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js